export default "<div [ngClass]=\"{'publishing': publishing}\" #publisherDiv></div>\r\n"